import { gsap } from '../animations';

/**
 * Animazioni del block "Dintorni — Esperienze":
 * - parallasse verticale della foto (scrub) mentre la riga attraversa il viewport,
 *   resa possibile dall'immagine sovradimensionata in overflow:hidden;
 * - reveal a stagger degli elementi di testo all'ingresso.
 * Con reduced-motion resta tutto fermo e visibile.
 */
export function initDintorniEsperienze() {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	document.querySelectorAll( '.tm-dinte__row' ).forEach( ( row ) => {
		const img = row.querySelector( '.tm-dinte__img' );
		if ( img ) {
			gsap.fromTo(
				img,
				{ yPercent: -8 },
				{
					yPercent: 8,
					ease: 'none',
					scrollTrigger: {
						trigger: row,
						start: 'top bottom',
						end: 'bottom top',
						scrub: true,
						// will-change solo mentre la riga è nel viewport.
						onToggle: ( self ) => {
							img.style.willChange = self.isActive ? 'transform' : 'auto';
						},
					},
				}
			);
		}

		const text = row.querySelector( '.tm-dinte__text' );
		if ( text && text.children.length ) {
			gsap.from( text.children, {
				y: 32,
				opacity: 0,
				duration: 0.8,
				ease: 'power3.out',
				stagger: 0.12,
				scrollTrigger: { trigger: text, start: 'top 82%', once: true },
			} );
		}
	} );
}
